import { render, staticRenderFns } from "./CustomersList.vue?vue&type=template&id=3ab91690"
import script from "./CustomersList.vue?vue&type=script&lang=js"
export * from "./CustomersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports